export const members = [
  {
    id: '1',
    name: 'Aubin Kegne',
    handle: '@aubin',
    email: 'hello***@greatpay.tech',
    avatarUrl: '/assets/images/team/aubin.jpg',
    status: 'active',
    role: 'Chief Executive Officer',
    rating: 5,
  },
  {
    id: '2',
    name: 'William Nelson',
    handle: '@william',
    email: 'hello***@greatpay.tech',
    avatarUrl: '/assets/images/team/william.jpeg',
    status: 'active',
    role: 'Expert business analyst',
    rating: 5,
  },
  {
    id: '3',
    name: 'Blériot Noguia',
    handle: '@bleriot',
    email: 'hello***@greatpay.tech',
    avatarUrl: '/assets/images/team/bleriot.png',
    status: 'active',
    role: 'Senior Full Stack Developer',
    rating: 4,
  },
  {
    id: '4',
    name: 'Pascal ALHADOUM',
    handle: '@pascal',
    email: 'hello***@greatpay.tech',
    avatarUrl: '/assets/images/team/pascal.jpeg',
    status: 'active',
    role: 'Senior Full Stack Developer',
    rating: 4,
  },
  {
    id: '5',
    name: 'Wakam Hermann',
    handle: '@hermann',
    email: 'hello***@greatpay.tech',
    avatarUrl: '/assets/images/team/hermann.jpeg',
    status: 'active',
    role: 'Senior Full Stack Developer',
    rating: 4,
  },
]